import { Box, CircularProgress, Typography } from "@mui/joy";
import { useSignOutMutation } from "@nerdjs/account-kit";
import { Purchases } from "@revenuecat/purchases-js";
import { ReactElement, useEffect, useState } from "react";
import { AppConfig } from "../../environement";
import { useLazyGetCurrentUserQuery } from "../../redux/user/userEndpoint";
import { RouterConfig } from "../config/routerConfig";
import { useMyMember } from "../../redux/member/memberHooks";
import { useLazyGetMemberQuery } from "../../redux/member/memberEndpoints";
import { useCurrentUser } from "../../redux/user/userHook";

/**
 *
 * @param root0
 * @param root0.children
 * @returns {ReactElement} OpaReady page
 */
export function OpaReady({ children }: { children: ReactElement }) {
  const [lazyGetMember, e] = useLazyGetMemberQuery();
  const { data: member, error } = e;
  const { me } = useCurrentUser();
  const status = (error as any)?.status;
  const { isSuccess } = useSignOutMutation()[1];
  const [i, setI] = useState<NodeJS.Timeout>();

  useEffect(() => {
    lazyGetMember(null);
  }, []);

  useEffect(() => {
    if (me?.uuid) {
      Purchases.configure(AppConfig.apiKeys.revenueCat, me.email);
    }
  }, [me]);

  useEffect(() => {
    if (member?.userUUID) {
      clearInterval(i);
    }
  }, [member]);

  useEffect(() => {
    //If signout success, refresh window to reset redux state
    if (isSuccess) {
      window.location.replace(RouterConfig.root);
    }
  }, [isSuccess]);

  useEffect(() => {
    console.log("useEffect", status, i);
    if (status === 403 && !i) {
      console.log("Starting the interval");
      setI(
        setInterval(() => {
          console.log("tick");
          lazyGetMember(null);
        }, 2000)
      );
    }
  }, [e]);

  console.log(e, status);

  return (
    <Box sx={{ display: "flex", flex: 1, position: "relative" }}>
      {status === 403 || !member ? (
        <Box
          sx={{
            position: "absolute",
            width: "100vw",
            height: "100vh",
            background: "#ffffffEE",
            zIndex: 9999,
            display: "flex",
            flexDirection: "column",
            gap: 2,
            alignItems: "center",
            justifyContent: "center",
            backdropFilter: "blur(8px)",
            textAlign: "center",
          }}
        >
          <CircularProgress />
          <Typography sx={{ fontWeight: 500 }}>
            Getting everything ready...
            <br />
            <Typography level="body2">This could take up to 15 sec</Typography>
          </Typography>
        </Box>
      ) : (
        []
      )}
      {member ? children : []}
    </Box>
  );
}
